import { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5006';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('pc_token'));
  const [loading, setLoading] = useState(true);

  // Configura axios global
  useEffect(() => {
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
      delete axios.defaults.headers.common['Authorization'];
    }
  }, [token]);

  // Valida token salvo no boot
  useEffect(() => {
    async function validar() {
      if (!token) {
        setLoading(false);
        return;
      }
      try {
        const { data } = await axios.get(`${API_URL}/auth/me`);
        setUser(data.user);
      } catch (_) {
        localStorage.removeItem('pc_token');
        setToken(null);
        setUser(null);
      } finally {
        setLoading(false);
      }
    }
    validar();
  }, []); // eslint-disable-line

  function aplicarSessao(data) {
    localStorage.setItem('pc_token', data.token);
    setToken(data.token);
    setUser(data.user);
    return data.user;
  }

  // Login por CPF (só dígitos) + senha
  async function login(cpf, senha) {
    const { data } = await axios.post(`${API_URL}/auth/login`, { cpf, senha });
    return aplicarSessao(data);
  }

  // Troca de senha — reemite o token sem o flag precisa_trocar_senha
  async function trocarSenha(senhaAtual, senhaNova) {
    const { data } = await axios.post(
      `${API_URL}/auth/trocar-senha`,
      { senha_atual: senhaAtual, senha_nova: senhaNova },
    );
    return aplicarSessao(data);
  }

  function logout() {
    localStorage.removeItem('pc_token');
    setToken(null);
    setUser(null);
  }

  function temPermissao(chave) {
    return !!user?.permissoes?.includes(chave);
  }

  return (
    <AuthContext.Provider value={{ user, token, loading, login, trocarSenha, logout, temPermissao }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth precisa estar dentro de AuthProvider');
  return ctx;
}
